import { FC, memo } from "react";
import styled from "styled-components";

export const OpenChatIcon: FC<{ width: string; height: string; }> = memo(({
  width,
  height
}) => (
  <Container
    width={width}
    height={height}
    className="voa_message_ai_icon_container"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 60 60" fill="none">
      <g clipPath="url(#clip0_178_680)">
      <path
        d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z"
        fill="#009BFF"
      />
      <path
        d="M45.0132 16H15.0132C9.49314 16 10.0131 19.3936 10.0131 23.5786V32.6791V34.2009C10.0131 38.3859 9.49314 41.7795 15.0132 41.7795H18C18.54 41.7795 19.16 42.1652 19.5 42.5L20.0131 43.5L20.5 45C21.82 46.3392 22.1931 46.3392 23.5131 45L24.5131 43.5C24.8931 43.1195 25.8931 41.7795 26.5131 41.7795H44.0132C49.5332 41.7795 50.0131 38.3859 50.0131 34.2009V23.5786C50.0131 19.3936 50.5332 16 45.0132 16Z"
        fill="white"
      />
      <path
        d="M13.5 32.6963C13.5 33.5333 14.38 34.2181 15.5 34.2181C16.62 34.2181 17.5 33.5333 17.5 32.6963C17.5 31.8593 16.6 31.1745 15.5 31.1745C14.4 31.1745 13.5 31.8593 13.5 32.6963Z"
        fill="#009BFF"
      />
      <path
        d="M19.5 32.6963C19.5 33.5333 20.38 34.2181 21.5 34.2181C22.62 34.2181 23.5 33.5333 23.5 32.6963C23.5 31.8593 22.6 31.1745 21.5 31.1745C20.4 31.1745 19.5 31.8593 19.5 32.6963Z"
        fill="#009BFF"
      />
      <g clipPath="url(#clip1_178_680)">
      <path
        d="M43.8743 26.2506C43.4526 26.2506 43.0731 24.9923 42.9164 24.6L42.1345 23.8499L41.42 23.0277C41.0313 22.8636 39.7412 22.4805 39.7494 22.0588C39.7577 21.6372 41.0258 21.2632 41.42 21.1138L42.2014 20.4373L42.9164 19.65C43.0731 19.2586 43.4517 18 43.8743 18C44.2968 18 44.6754 19.2577 44.8321 19.65L45.5517 20.4483L46.35 21.1679C46.7414 21.3246 48 21.7032 48 22.1257C48 22.5483 46.7423 22.9269 46.35 23.0836L45.5517 23.8032L44.8321 24.6C44.6754 24.9914 44.2968 26.2506 43.8743 26.2506ZM46.7726 27.6008C45.6525 28.0637 44.3729 28.2195 43.0365 27.9564C40.5432 27.4651 38.5349 25.4568 38.0436 22.9635C37.7805 21.6271 37.9354 20.3475 38.3992 19.2274C38.6412 18.6416 38.2122 18.0009 37.5789 18.0009H30.5831C28.0523 18.0009 26 20.0533 26 22.5841V35.4169C26 37.9477 28.0523 40 30.5831 40H43.4159C45.9468 40 47.9991 37.9477 47.9991 35.4169V28.4211C47.9991 27.7878 47.3584 27.3588 46.7726 27.6008ZM38.556 35.4169C38.1499 35.4169 37.7943 35.1474 37.6833 34.7569L37.094 32.667H32.322L31.7326 34.7569C31.6226 35.1474 31.266 35.4169 30.86 35.4169C30.2605 35.4169 29.826 34.8449 29.9864 34.2674L31.4031 29.1765L32.8197 24.0855C32.949 23.5282 33.3156 23.0589 33.8262 22.7976C34.3468 22.53 34.9445 22.5135 35.5119 22.7518C36.0499 22.9773 36.4624 23.5007 36.6155 24.1588L39.4304 34.2683C39.5909 34.8458 39.1573 35.4178 38.5569 35.4178L38.556 35.4169ZM43.4159 34.5002C43.4159 35.0062 43.0053 35.4169 42.4993 35.4169C41.9933 35.4169 41.5827 35.0062 41.5827 34.5002V29.9978C41.5827 29.4918 41.9933 29.0811 42.4993 29.0811C43.0053 29.0811 43.4159 29.4918 43.4159 29.9978V34.5002ZM34.6071 24.5686L32.839 30.8337H36.5761L34.8079 24.5686C34.7813 24.4641 34.6328 24.4641 34.6071 24.5686Z"
        fill="#009BFF"
      />
      </g>
      </g>
      <defs>
        <clipPath id="clip0_178_680">
          <rect width="60" height="60" fill="white"/>
        </clipPath>
        <clipPath id="clip1_178_680">
          <rect width="22" height="22" fill="white" transform="translate(26 18)"/>
        </clipPath>
      </defs>
    </svg>
  </Container>
));


const Container = styled.div<{ width: string; height: string; }>`
  position: relative;
  width: 40px;
  height: 40px;

  @media (min-width: 768px) {
    bottom: unset;
    height: ${(props) => props.height};
    width: ${(props) => props.width};
  }

  & path:nth-child(1),
  & path:nth-child(3),
  & path:nth-child(4),
  & path:nth-child(5) {
    fill: ${(props) => props.theme.themeConfig.chatButton.openedIcon.styles.background} !important;
  }
`;
